import { Icon, styled } from '@fluentui/react';
import * as React from 'react';
import { Device } from '../../../models/apiModels';
import { IconNames } from '../../../models/constants/constants';
import { IOutdatedDevicesAlertStyles, getOutdatedDevicesAlertClassNames, getOutdatedDevicesAlertStyles } from '../styles/outdatedDevicesAlertStyles';
import { IStyledComponent } from '../styles/themesUI';

interface OutdatedDeviceProps {
  device: Device;
  outdatedDeviceStatusText: string;
}

type IOutdatedDeviceProps = OutdatedDeviceProps & IStyledComponent<IOutdatedDevicesAlertStyles>

const OutdatedDeviceC = (props: IOutdatedDeviceProps) => {
  const classNames = getOutdatedDevicesAlertClassNames(props.styles, { theme: props.theme });
  return (
    <div className={classNames.outdatedDeviceContainer}>
      <div className={classNames.outdatedDevice}>
        <div className={classNames.deviceLogoAndInfo}>
          <Icon className={classNames.deviceLogo} iconName={IconNames.ComputerIcon} />
          <div className={classNames.deviceInfo}>
            <div className={classNames.deviceName + ' ' + classNames.overflowTextElement}>{props.device.Name}</div>
            <div className={classNames.deviceModel + ' ' + classNames.overflowTextElement}>{props.device.Model}</div>
          </div>
        </div>
        <div className={classNames.deviceStatus + ' ' + classNames.overflowTextElement}>
          {props.outdatedDeviceStatusText}
        </div>
      </div>
      <div className={classNames.deviceDivider}><hr /></div>
    </div>
  );
};

export const OutdatedDevice = styled(OutdatedDeviceC, getOutdatedDevicesAlertStyles);
